export enum UniqueValueConstraint {
	Tenant,
	Client,
	Project,
	Flow,
}
